import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Icon from '../Icon'

const Button = ({
  classes,
  className,
  isDisabled,
  children,
  icon,
  iconPosition,
  onClick,
  color,
  name,
  ...other
}) => {
  return (
    <button
      {...other}
      name={name}
      className={classNames(classes.button, className, {
        [classes.colorGreen]: color === 'green',
        [classes.colorRuby]: color === 'ruby',
        [classes.colorBlue]: color === 'blue',
        [classes.colorWhite]: color === 'white',
        [classes.colorTransparent]: color === 'transparent',
        [classes.disabled]: isDisabled,
      })}
      disabled={isDisabled}
      onClick={e => {
        return !isDisabled && onClick ? onClick(e) : false
      }}
    >
      {icon && (
        <Icon
          name={icon}
          className={classNames(classes.icon, {
            [classes.iconRight]: iconPosition === 'right',
          })}
        />
      )}
      <span className={classes.children}>{children}</span>
    </button>
  )
}

Button.propTypes = {
  classes: PropTypes.shape({
    button: PropTypes.string,
    colorGreen: PropTypes.string,
    colorWhite: PropTypes.string,
    disabled: PropTypes.string,
    colorTransparent: PropTypes.string,
    children: PropTypes.string,
    icon: PropTypes.string,
    iconRight: PropTypes.string,
  }),
  className: PropTypes.string,
  isDisabled: PropTypes.bool,
  children: PropTypes.string,
  icon: PropTypes.string,
  iconPosition: PropTypes.string,
  onClick: PropTypes.func,
  color: PropTypes.string,
  name: PropTypes.string,
}

Button.defaultProps = {
  iconPosition: 'left',
  color: 'ruby',
}

export default Button
